import { FC } from 'react'
import { FlowCardButtonLink } from '@components/FlowCard'
import { RouteError } from '@src/errors/RouteError'
import { ErrorComponentProps, SearchParamError } from '@tanstack/react-router'

import AlertIcon from '@/assets/images/alert-illustration.svg'

import {
  FlowCard,
  FlowCardFooter,
  FlowCardHeader,
  FlowCardMain,
} from '../FlowCard'

export const GenericErrorCard: FC<ErrorComponentProps> = ({ error }) => {
  const isSearchParamError = error instanceof SearchParamError
  const isRouteError = error instanceof RouteError

  let message = 'An error occurred. Please try again later.'
  let title = 'Oops! Something went wrong.'

  if (isSearchParamError) {
    message = 'Invalid search parameters.'
  } else if (isRouteError) {
    message = error.message
    if (error.title) {
      title = error.title
    }
  }
  return (
    <FlowCard>
      <FlowCardMain showBack={false}>
        <FlowCardHeader icon={<AlertIcon />} subtitle={message}>
          {title}
        </FlowCardHeader>
      </FlowCardMain>
      <FlowCardFooter>
        <FlowCardButtonLink href="https://support.branchapp.com/">
          Contact Support
        </FlowCardButtonLink>
      </FlowCardFooter>
    </FlowCard>
  )
}
